/**
 * 本地存储
 * Created by slipkinem on 2018/8/13 at 10:49.
 */
import { env } from '../util';
const keyPrefix = `AppFinanceH5_20191101_${env()}_`;
class Storage {
    constructor(type) {
        this.type = type;
        // 方便存款等其他项目动态获取缓存前缀
        window[type].setItem('helloFinanceStorageKeyPrefix', keyPrefix);
    }
    set(key, value, expires = 60 * 60 * 24 * 30) {
        const o = {
            $$expires: new Date().getTime() + 1000 * expires,
            value
        };
        window[this.type].setItem(this.prefixKey(key), JSON.stringify(o));
    }
    get(key) {
        const o = JSON.parse(window[this.type].getItem(this.prefixKey(key)) || 'null');
        if (!o) {
            return null;
        }
        if (new Date().getTime() > o.$$expires) {
            this.remove(key);
            return null;
        }
        return o.value;
    }
    remove(key) {
        window[this.type].removeItem(this.prefixKey(key));
    }
    // 一次性取出然后删除
    getAndRemove(key) {
        const v = this.get(key);
        this.remove(key);
        return v;
    }
    prefixKey(key) {
        return keyPrefix + key;
    }
}
export const local = new Storage('localStorage');
export const session = new Storage('sessionStorage');
//# sourceMappingURL=storage.js.map